import { useState } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import SplashScreen from "./components/SplashScreen";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";

function App() {
  const [showSplash, setShowSplash] = useState<boolean>(true);

  const handleAccept = () => {
    setShowSplash(false);
  };

  if (showSplash) {
    return <SplashScreen onAccept={handleAccept} />;
  }

  return (
    <ThemeProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
